import { createAction, props } from '@ngrx/store';
import { SortingColumnType } from 'src/app/my-bill/models/odb-usage-l4.model';
import { IOdbUsageLevel4Response } from 'src/app/my-bill/models/odb-usage-level-4.model';

export const GET_ODB_USAGE_LEVEL_4_REQUEST = 'GET_ODB_USAGE_LEVEL_4_REQUEST';
export const GET_ODB_USAGE_LEVEL_4_SUCCESS = 'GET_ODB_USAGE_LEVEL_4_SUCCESS';
export const GET_ODB_USAGE_LEVEL_4_FAILURE = 'GET_ODB_USAGE_LEVEL_4_FAILURE';
export const GET_SORTED_ODB_USAGE_BY_COLUMN = 'GET_SORTED_ODB_USAGE_BY_COLUMN';

export const getOdbUsageLevel4Request = createAction(
  GET_ODB_USAGE_LEVEL_4_REQUEST,
  props<{
    documentReference: string;
    billableIdentifierNumber: string;
    sectionOrItemIdentifier: string;
    paNumber: string;
  }>()
);

export const getOdbUsageLevel4Success = createAction(
  GET_ODB_USAGE_LEVEL_4_SUCCESS,
  props<{
    documentReference: string;
    sectionOrItemIdentifier: string;
    payload: IOdbUsageLevel4Response;
  }>()
);

export const getOdbUsageLevel4Failure = createAction(
  GET_ODB_USAGE_LEVEL_4_FAILURE,
  props<{
    documentReference: string;
    sectionOrItemIdentifier: string;
    code?: string;
  }>()
);

export const getSortedOdbUsageByColumn = createAction(
  GET_SORTED_ODB_USAGE_BY_COLUMN,
  props<{
    documentReference: string;
    sectionOrItemIdentifier: string;
    sortingColumn: SortingColumnType;
  }>()
);
